import React from "react";

interface IntroCardProps {
  lenderName: string;
  adminName?: string;
}
const IntroCard = ({ lenderName, adminName }: IntroCardProps) => (
  <div className="introCard">
    <span className="introCard__icon">📋</span>
    <div className="introCard__text">
      <strong>
        Action Required — Review &amp; Acknowledge Project Requirements
      </strong>
      {lenderName} and Consultant Services {adminName} have established the
      following requirements for this project. Please read each item carefully,
      check the box to confirm you understand and agree, and sign at the bottom.
      Your acknowledgment is required before the first draw can be released.
    </div>
  </div>
);

export default IntroCard;
